import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "UiLoadingContentWrapper relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-14 w-full animate-fade-in-down"
}

import { UiLoadingSpinner } from '@/components/common/ui'
import { computed } from 'vue'
type Props = {
    isLoading: boolean
    text?: string | undefined
    fullScreen?: boolean
    showContentOnLoading?: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    isLoading: { type: Boolean, required: true, default: false },
    text: { type: [String, null], required: false, default: undefined },
    fullScreen: { type: Boolean, required: false, default: false },
    showContentOnLoading: { type: Boolean, required: false, default: false }
  },
  setup(__props: any) {

const props = __props as { isLoading: boolean, text: string | undefined, fullScreen: boolean, showContentOnLoading: boolean }


const showContent = computed(() => {
    if (props.showContentOnLoading) {
        return true
    }
    return !props.isLoading
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_Teleport, {
            disabled: !props.fullScreen,
            to: "body"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'full-screen-loader': props.fullScreen })
            }, [
              _createVNode(_unref(UiLoadingSpinner), { text: __props.text }, null, 8, ["text"])
            ], 2)
          ], 8, ["disabled"]))
        ]))
      : _createCommentVNode("", true),
    (_unref(showContent))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({ 'animate-fade-in-up': !props.isLoading })
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})